import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=4a3e8493&"
import script from "./identity.vue?vue&type=script&lang=js&"
export * from "./identity.vue?vue&type=script&lang=js&"
import style0 from "./identity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports